import { render, staticRenderFns } from "./order-paymentstatus.vue?vue&type=template&id=c57f792c"
import script from "./order-paymentstatus.vue?vue&type=script&lang=js"
export * from "./order-paymentstatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports